const faqTitle = document.querySelectorAll(".recruit-people-faq__item");
const faqContent = document.querySelectorAll(".recruit-people-faq__answer");

faqTitle.forEach((item, index) => {
  item.addEventListener("click", () => {
    if (item.classList.contains("is-active")) {
      faqContent[index].style.height = 0;
      item.classList.toggle("is-active");
      faqContent[index].classList.toggle("is-active");
    } else {
      faqContent[index].style.height = "auto"; //いったんautoに
      let itemHeight = faqContent[index].offsetHeight; //autoにした要素から高さを取得
      faqContent[index].style.height = itemHeight + "px";
      faqContent[index].animate(
        [
          //高さ0から取得した高さまでのアニメーション
          { height: 0 },
          { height: itemHeight + "px" },
        ],
        {
          duration: 300, //アニメーションの時間（ms）
        }
      );
      item.classList.toggle("is-active");
      faqContent[index].classList.toggle("is-active");
    }
  });
});
